import {IStore} from "modules/types";

export const getJSONs = ({jsons}: IStore) => jsons;
export const getPrizes = ({jsons}: IStore) => jsons.prizes || [];
export const getFAQs = ({jsons}: IStore) => jsons.faqs;
export const getRules = ({jsons}: IStore) => jsons.rules;
export const getPrivacyPolicy = ({jsons}: IStore) => jsons.privacy_policy;
export const getTerms = ({jsons}: IStore) => jsons.terms;
export const getGuidelines = ({jsons}: IStore) => jsons.guidelines;
export const isHelpRequested = ({jsons}: IStore) => jsons.is_data_requested;
